// Complete Chilean Judicial System Database
// Tribunales Ordinarios, Especiales y Colegiados

export const JUDICIAL_SYSTEM = {
  // ==========================================
  // TRIBUNALES ORDINARIOS
  // ==========================================
  ordinarios: {
    title: "Tribunales Ordinarios",
    description: "Conforman la estructura base del Poder Judicial chileno",
    tribunales: {
      corte_suprema: {
        nombre: "Corte Suprema",
        tipo: "Superior",
        sede: "Santiago",
        composicion: "21 ministros",
        competencia: [
          "Recurso de casación en el fondo y forma",
          "Recurso de revisión",
          "Recurso de queja",
          "Recurso de inaplicabilidad (antes de 2005)",
          "Contiendas de competencia",
          "Desafueros de parlamentarios"
        ],
        procedimientos: [
          { nombre: "Casación en el Fondo", plazo: "15 días desde notificación" },
          { nombre: "Casación en la Forma", plazo: "15 días desde notificación" },
          { nombre: "Recurso de Queja", plazo: "5 días hábiles" },
          { nombre: "Recurso de Revisión", plazo: "1 año desde sentencia firme" }
        ],
        documentos: [
          "Escrito de casación",
          "Recurso de queja",
          "Solicitud de revisión"
        ],
        icon: "Scale"
      },
      corte_apelaciones: {
        nombre: "Cortes de Apelaciones",
        tipo: "Segunda Instancia",
        sedes: ["Santiago", "Valparaíso", "Concepción", "Temuco", "Antofagasta", "La Serena", "Talca", "Chillán", "Puerto Montt", "Punta Arenas", "Copiapó", "Rancagua", "Iquique", "Arica", "Valdivia", "Coyhaique", "San Miguel"],
        composicion: "Variable según corte (4-31 ministros)",
        competencia: [
          "Recurso de apelación",
          "Recurso de nulidad laboral",
          "Recurso de protección",
          "Recurso de amparo",
          "Consultas",
          "Recursos de hecho"
        ],
        procedimientos: [
          { nombre: "Apelación Civil", plazo: "10 días" },
          { nombre: "Apelación Penal", plazo: "5 días" },
          { nombre: "Recurso de Protección", plazo: "30 días corridos" },
          { nombre: "Recurso de Amparo", plazo: "Sin plazo (urgente)" },
          { nombre: "Nulidad Laboral", plazo: "10 días hábiles" }
        ],
        documentos: [
          "Escrito de apelación",
          "Recurso de protección",
          "Acción de amparo",
          "Recurso de nulidad"
        ],
        icon: "Building2"
      },
      juzgado_letras: {
        nombre: "Juzgados de Letras",
        tipo: "Primera Instancia",
        competencia: [
          "Causas civiles de mayor cuantía (>500 UTM)",
          "Causas civiles de menor cuantía (10-500 UTM)",
          "Causas civiles de mínima cuantía (<10 UTM)",
          "Juicios ejecutivos",
          "Gestiones voluntarias"
        ],
        procedimientos: [
          { nombre: "Juicio Ordinario", plazo: "15 días para contestar" },
          { nombre: "Juicio Sumario", plazo: "8 días para contestar" },
          { nombre: "Juicio Ejecutivo", plazo: "4 días para oponer excepciones" },
          { nombre: "Gestión Voluntaria", plazo: "Variable" }
        ],
        documentos: [
          "Demanda civil",
          "Contestación de demanda",
          "Demanda ejecutiva",
          "Solicitud de gestión voluntaria",
          "Tercerías"
        ],
        icon: "Gavel"
      },
      juzgado_garantia: {
        nombre: "Juzgados de Garantía",
        tipo: "Primera Instancia Penal",
        competencia: [
          "Control de la investigación penal",
          "Audiencias de formalización",
          "Medidas cautelares personales y reales",
          "Procedimiento abreviado",
          "Procedimiento simplificado",
          "Procedimiento monitorio"
        ],
        procedimientos: [
          { nombre: "Formalización", plazo: "Según fiscal" },
          { nombre: "Procedimiento Abreviado", plazo: "Hasta cierre investigación" },
          { nombre: "Procedimiento Simplificado", plazo: "Faltas y simples delitos" },
          { nombre: "Procedimiento Monitorio", plazo: "Faltas con multa" }
        ],
        documentos: [
          "Querella criminal",
          "Solicitud de sobreseimiento",
          "Solicitud de medidas cautelares",
          "Acuerdo reparatorio"
        ],
        icon: "Shield"
      },
      tribunal_oral_penal: {
        nombre: "Tribunales de Juicio Oral en lo Penal",
        tipo: "Primera Instancia Penal",
        composicion: "3 jueces (unipersonal en simplificado)",
        competencia: [
          "Juicio oral en crímenes y simples delitos",
          "Conocer del procedimiento simplificado cuando proceda"
        ],
        procedimientos: [
          { nombre: "Juicio Oral", plazo: "Según auto de apertura" }
        ],
        documentos: [
          "Acusación fiscal",
          "Adhesión a la acusación",
          "Demanda civil en proceso penal"
        ],
        icon: "Users"
      }
    }
  },

  // ==========================================
  // TRIBUNALES ESPECIALES
  // ==========================================
  especiales: {
    title: "Tribunales Especiales",
    description: "Tribunales con competencia en materias específicas",
    tribunales: {
      juzgado_familia: {
        nombre: "Juzgados de Familia",
        tipo: "Primera Instancia",
        competencia: [
          "Cuidado personal de hijos",
          "Relación directa y regular (visitas)",
          "Pensión de alimentos",
          "Divorcio y nulidad de matrimonio",
          "Violencia intrafamiliar",
          "Adopción",
          "Filiación",
          "Autorización salida del país",
          "Medidas de protección de menores"
        ],
        procedimientos: [
          { nombre: "Alimentos", plazo: "Audiencia preparatoria 10 días" },
          { nombre: "Divorcio Mutuo Acuerdo", plazo: "1 año de cese convivencia" },
          { nombre: "Divorcio Unilateral", plazo: "3 años de cese convivencia" },
          { nombre: "VIF", plazo: "Urgente, medidas inmediatas" },
          { nombre: "Cuidado Personal", plazo: "Audiencia 15 días" }
        ],
        documentos: [
          "Demanda de alimentos",
          "Demanda de divorcio",
          "Demanda de cuidado personal",
          "Demanda de relación directa y regular",
          "Denuncia por VIF",
          "Solicitud de autorización salida país",
          "Solicitud de medida de protección"
        ],
        leyes: ["Ley 19.968", "Ley 14.908", "Ley 19.947", "Ley 20.066"],
        icon: "Heart"
      },
      juzgado_trabajo: {
        nombre: "Juzgados de Letras del Trabajo",
        tipo: "Primera Instancia",
        competencia: [
          "Controversias laborales individuales",
          "Despido injustificado",
          "Cobro de prestaciones laborales",
          "Tutela de derechos fundamentales",
          "Prácticas antisindicales",
          "Accidentes del trabajo"
        ],
        procedimientos: [
          { nombre: "Procedimiento de Aplicación General", plazo: "Audiencia 35 días" },
          { nombre: "Procedimiento Monitorio", plazo: "Cuantía < 10 IMM" },
          { nombre: "Tutela Laboral", plazo: "Preferente y urgente" },
          { nombre: "Reclamación por Multas", plazo: "15 días hábiles" }
        ],
        documentos: [
          "Demanda laboral",
          "Demanda de tutela laboral",
          "Demanda por despido injustificado",
          "Demanda por accidente del trabajo",
          "Denuncia prácticas antisindicales"
        ],
        leyes: ["Código del Trabajo", "Ley 16.744"],
        icon: "Briefcase"
      },
      juzgado_cobranza: {
        nombre: "Juzgados de Cobranza Laboral y Previsional",
        tipo: "Primera Instancia",
        competencia: [
          "Ejecución de sentencias laborales",
          "Cobro de cotizaciones previsionales",
          "Cobro de multas administrativas laborales"
        ],
        procedimientos: [
          { nombre: "Ejecución Laboral", plazo: "Según título ejecutivo" },
          { nombre: "Cobro Previsional", plazo: "Demanda ejecutiva" }
        ],
        documentos: [
          "Demanda ejecutiva laboral",
          "Demanda de cobro previsional"
        ],
        icon: "Banknote"
      },
      juzgado_policia_local: {
        nombre: "Juzgados de Policía Local",
        tipo: "Primera Instancia",
        competencia: [
          "Infracciones de tránsito",
          "Infracciones municipales",
          "Ley del consumidor (hasta 10 UTM)",
          "Ley de alcoholes",
          "Infracciones sanitarias menores"
        ],
        procedimientos: [
          { nombre: "Procedimiento Contravencional", plazo: "Citación a comparendo" },
          { nombre: "Reclamo Consumidor", plazo: "6 meses desde infracción" }
        ],
        documentos: [
          "Denuncia infraccional",
          "Reclamo ley del consumidor",
          "Descargos"
        ],
        leyes: ["Ley 15.231", "Ley 18.287", "Ley 19.496"],
        icon: "Car"
      },
      tribunal_militar: {
        nombre: "Tribunales Militares",
        tipo: "Especial Militar",
        composicion: "Juzgados Militares, Cortes Marciales, Corte Suprema (sala penal)",
        competencia: [
          "Delitos militares en tiempo de paz",
          "Delitos comunes cometidos por militares en acto de servicio"
        ],
        procedimientos: [
          { nombre: "Proceso Militar", plazo: "Según Código de Justicia Militar" }
        ],
        documentos: [
          "Querella militar",
          "Denuncia ante fiscalía militar"
        ],
        leyes: ["Código de Justicia Militar"],
        icon: "Shield"
      }
    }
  },

  // ==========================================
  // TRIBUNALES COLEGIADOS / AUTÓNOMOS
  // ==========================================
  colegiados: {
    title: "Tribunales Colegiados y Autónomos",
    description: "Tribunales especializados fuera del Poder Judicial",
    tribunales: {
      tribunal_constitucional: {
        nombre: "Tribunal Constitucional",
        tipo: "Autónomo",
        sede: "Santiago",
        composicion: "10 ministros",
        competencia: [
          "Control de constitucionalidad de leyes",
          "Inaplicabilidad por inconstitucionalidad",
          "Inconstitucionalidad de preceptos legales",
          "Control de decretos supremos",
          "Inhabilidades de ministros"
        ],
        procedimientos: [
          { nombre: "Requerimiento de Inaplicabilidad", plazo: "Mientras pende gestión" },
          { nombre: "Acción de Inconstitucionalidad", plazo: "Después de inaplicabilidad" },
          { nombre: "Control Preventivo", plazo: "Antes de promulgación" }
        ],
        documentos: [
          "Requerimiento de inaplicabilidad",
          "Acción de inconstitucionalidad",
          "Requerimiento de control preventivo"
        ],
        leyes: ["Constitución Política", "Ley 17.997"],
        icon: "BookOpen"
      },
      tricel: {
        nombre: "Tribunal Calificador de Elecciones (TRICEL)",
        tipo: "Autónomo Electoral",
        sede: "Santiago",
        composicion: "5 miembros",
        competencia: [
          "Calificación de elecciones de Presidente, Senadores y Diputados",
          "Plebiscitos",
          "Reclamaciones electorales",
          "Proclamación de candidatos electos"
        ],
        procedimientos: [
          { nombre: "Reclamación Electoral", plazo: "10 días desde elección" }
        ],
        documentos: [
          "Reclamación electoral",
          "Solicitud de rectificación"
        ],
        leyes: ["Constitución Política", "Ley 18.460"],
        icon: "Vote"
      },
      ter: {
        nombre: "Tribunales Electorales Regionales (TER)",
        tipo: "Autónomo Electoral",
        composicion: "3 miembros por región",
        competencia: [
          "Calificación de elecciones municipales",
          "Elecciones de organizaciones sociales",
          "Reclamaciones electorales regionales"
        ],
        procedimientos: [
          { nombre: "Reclamación Electoral Regional", plazo: "10 días" }
        ],
        documentos: [
          "Reclamación electoral regional"
        ],
        icon: "MapPin"
      },
      tdlc: {
        nombre: "Tribunal de Defensa de la Libre Competencia (TDLC)",
        tipo: "Especial Económico",
        sede: "Santiago",
        composicion: "5 ministros",
        competencia: [
          "Infracciones al DL 211 (libre competencia)",
          "Consultas sobre operaciones de concentración",
          "Demandas por conductas anticompetitivas",
          "Colusión, abuso de posición dominante"
        ],
        procedimientos: [
          { nombre: "Procedimiento Contencioso", plazo: "Según DL 211" },
          { nombre: "Consulta de Concentración", plazo: "60 días" }
        ],
        documentos: [
          "Demanda ante TDLC",
          "Consulta de concentración",
          "Requerimiento FNE"
        ],
        leyes: ["DL 211"],
        icon: "TrendingUp"
      },
      tcp: {
        nombre: "Tribunal de Contratación Pública",
        tipo: "Especial Administrativo",
        sede: "Santiago",
        composicion: "3 integrantes",
        competencia: [
          "Impugnación de actos en licitaciones públicas",
          "Demandas contra organismos públicos por contrataciones"
        ],
        procedimientos: [
          { nombre: "Acción de Impugnación", plazo: "10 días hábiles desde publicación" }
        ],
        documentos: [
          "Demanda de impugnación",
          "Solicitud de medida cautelar"
        ],
        leyes: ["Ley 19.886"],
        icon: "FileCheck"
      },
      tribunal_ambiental: {
        nombre: "Tribunales Ambientales",
        tipo: "Especial Ambiental",
        sedes: ["Antofagasta (1°)", "Santiago (2°)", "Valdivia (3°)"],
        composicion: "3 ministros cada uno",
        competencia: [
          "Reclamaciones contra resoluciones de la SMA",
          "Demandas por daño ambiental",
          "Reclamaciones contra RCA",
          "Consultas sobre normativa ambiental"
        ],
        procedimientos: [
          { nombre: "Reclamación contra SMA", plazo: "15 días hábiles" },
          { nombre: "Reclamación contra RCA", plazo: "30 días hábiles" },
          { nombre: "Demanda por Daño Ambiental", plazo: "5 años prescripción" }
        ],
        documentos: [
          "Reclamación ambiental",
          "Demanda por daño ambiental",
          "Solicitud de medida cautelar ambiental"
        ],
        leyes: ["Ley 20.600", "Ley 19.300"],
        icon: "Leaf"
      },
      tta: {
        nombre: "Tribunales Tributarios y Aduaneros (TTA)",
        tipo: "Especial Tributario",
        sedes: "15 tribunales a nivel nacional",
        composicion: "1 juez tributario y aduanero",
        competencia: [
          "Reclamaciones tributarias",
          "Reclamaciones aduaneras",
          "Infracciones tributarias",
          "Vulneración de derechos del contribuyente"
        ],
        procedimientos: [
          { nombre: "Procedimiento General de Reclamación", plazo: "90 días desde liquidación" },
          { nombre: "Procedimiento de Vulneración de Derechos", plazo: "15 días" },
          { nombre: "Procedimiento Especial de Reclamo por Vulneración", plazo: "15 días hábiles" }
        ],
        documentos: [
          "Reclamo tributario",
          "Reclamo aduanero",
          "Reclamo por vulneración de derechos"
        ],
        leyes: ["Código Tributario", "Ordenanza de Aduanas", "Ley 20.322"],
        icon: "Receipt"
      }
    }
  }
};

// Competence matcher - determines which tribunal handles a specific case
export const COMPETENCE_MATCHER = {
  keywords: {
    // Civil
    "compraventa": { tribunal: "juzgado_letras", tipo: "ordinarios" },
    "arriendo": { tribunal: "juzgado_letras", tipo: "ordinarios" },
    "hipoteca": { tribunal: "juzgado_letras", tipo: "ordinarios" },
    "comodato": { tribunal: "juzgado_letras", tipo: "ordinarios" },
    "cobro de pesos": { tribunal: "juzgado_letras", tipo: "ordinarios" },
    "ejecutivo": { tribunal: "juzgado_letras", tipo: "ordinarios" },
    "prescripción": { tribunal: "juzgado_letras", tipo: "ordinarios" },
    "servidumbre": { tribunal: "juzgado_letras", tipo: "ordinarios" },
    "usufructo": { tribunal: "juzgado_letras", tipo: "ordinarios" },
    
    // Familia
    "divorcio": { tribunal: "juzgado_familia", tipo: "especiales" },
    "pensión de alimentos": { tribunal: "juzgado_familia", tipo: "especiales" },
    "alimentos": { tribunal: "juzgado_familia", tipo: "especiales" },
    "cuidado personal": { tribunal: "juzgado_familia", tipo: "especiales" },
    "visitas": { tribunal: "juzgado_familia", tipo: "especiales" },
    "relación directa": { tribunal: "juzgado_familia", tipo: "especiales" },
    "violencia intrafamiliar": { tribunal: "juzgado_familia", tipo: "especiales" },
    "vif": { tribunal: "juzgado_familia", tipo: "especiales" },
    "adopción": { tribunal: "juzgado_familia", tipo: "especiales" },
    "filiación": { tribunal: "juzgado_familia", tipo: "especiales" },
    "tuición": { tribunal: "juzgado_familia", tipo: "especiales" },
    
    // Laboral
    "despido": { tribunal: "juzgado_trabajo", tipo: "especiales" },
    "finiquito": { tribunal: "juzgado_trabajo", tipo: "especiales" },
    "laboral": { tribunal: "juzgado_trabajo", tipo: "especiales" },
    "trabajo": { tribunal: "juzgado_trabajo", tipo: "especiales" },
    "tutela laboral": { tribunal: "juzgado_trabajo", tipo: "especiales" },
    "accidente laboral": { tribunal: "juzgado_trabajo", tipo: "especiales" },
    "cotizaciones": { tribunal: "juzgado_cobranza", tipo: "especiales" },
    "previsional": { tribunal: "juzgado_cobranza", tipo: "especiales" },
    
    // Penal
    "robo": { tribunal: "juzgado_garantia", tipo: "ordinarios" },
    "hurto": { tribunal: "juzgado_garantia", tipo: "ordinarios" },
    "estafa": { tribunal: "juzgado_garantia", tipo: "ordinarios" },
    "lesiones": { tribunal: "juzgado_garantia", tipo: "ordinarios" },
    "homicidio": { tribunal: "juzgado_garantia", tipo: "ordinarios" },
    "delito": { tribunal: "juzgado_garantia", tipo: "ordinarios" },
    "crimen": { tribunal: "juzgado_garantia", tipo: "ordinarios" },
    "querella": { tribunal: "juzgado_garantia", tipo: "ordinarios" },
    
    // Policía Local
    "tránsito": { tribunal: "juzgado_policia_local", tipo: "especiales" },
    "parte": { tribunal: "juzgado_policia_local", tipo: "especiales" },
    "multa de tránsito": { tribunal: "juzgado_policia_local", tipo: "especiales" },
    "consumidor": { tribunal: "juzgado_policia_local", tipo: "especiales" },
    "sernac": { tribunal: "juzgado_policia_local", tipo: "especiales" },
    
    // Constitucional
    "inconstitucional": { tribunal: "tribunal_constitucional", tipo: "colegiados" },
    "inaplicabilidad": { tribunal: "tribunal_constitucional", tipo: "colegiados" },
    "constitucional": { tribunal: "tribunal_constitucional", tipo: "colegiados" },
    
    // Libre Competencia
    "colusión": { tribunal: "tdlc", tipo: "colegiados" },
    "monopolio": { tribunal: "tdlc", tipo: "colegiados" },
    "libre competencia": { tribunal: "tdlc", tipo: "colegiados" },
    "concentración": { tribunal: "tdlc", tipo: "colegiados" },
    
    // Ambiental
    "daño ambiental": { tribunal: "tribunal_ambiental", tipo: "colegiados" },
    "contaminación": { tribunal: "tribunal_ambiental", tipo: "colegiados" },
    "impacto ambiental": { tribunal: "tribunal_ambiental", tipo: "colegiados" },
    "rca": { tribunal: "tribunal_ambiental", tipo: "colegiados" },
    
    // Tributario
    "impuestos": { tribunal: "tta", tipo: "colegiados" },
    "sii": { tribunal: "tta", tipo: "colegiados" },
    "tributario": { tribunal: "tta", tipo: "colegiados" },
    "liquidación": { tribunal: "tta", tipo: "colegiados" },
    "aduanas": { tribunal: "tta", tipo: "colegiados" },
    
    // Contratación Pública
    "licitación": { tribunal: "tcp", tipo: "colegiados" },
    "mercado público": { tribunal: "tcp", tipo: "colegiados" },
    "chilecompra": { tribunal: "tcp", tipo: "colegiados" },
    
    // Electoral
    "elección": { tribunal: "tricel", tipo: "colegiados" },
    "votación": { tribunal: "tricel", tipo: "colegiados" },
    "electoral": { tribunal: "tricel", tipo: "colegiados" }
  }
};

// Recursos procesales por tipo
export const RECURSOS_PROCESALES = {
  ordinarios: [
    {
      nombre: "Recurso de Reposición",
      descripcion: "Ante el mismo tribunal que dictó la resolución",
      plazo: "5 días desde notificación",
      procedencia: "Autos y decretos",
      tribunal: "Mismo tribunal"
    },
    {
      nombre: "Recurso de Apelación",
      descripcion: "Ante tribunal superior jerárquico",
      plazo: "10 días (civil), 5 días (penal)",
      procedencia: "Sentencias definitivas e interlocutorias",
      tribunal: "Corte de Apelaciones"
    },
    {
      nombre: "Recurso de Hecho",
      descripcion: "Cuando se deniega apelación procedente",
      plazo: "5 días desde denegación",
      procedencia: "Resolución que deniega apelación",
      tribunal: "Corte de Apelaciones"
    }
  ],
  extraordinarios: [
    {
      nombre: "Recurso de Casación en la Forma",
      descripcion: "Por vicios de procedimiento",
      plazo: "15 días desde notificación",
      procedencia: "Sentencias definitivas o interlocutorias que pongan término al juicio",
      tribunal: "Corte de Apelaciones o Corte Suprema"
    },
    {
      nombre: "Recurso de Casación en el Fondo",
      descripcion: "Por infracción de ley que influye en lo dispositivo",
      plazo: "15 días desde notificación",
      procedencia: "Sentencias definitivas inapelables de segunda instancia",
      tribunal: "Corte Suprema"
    },
    {
      nombre: "Recurso de Revisión",
      descripcion: "Contra sentencias firmes por causales taxativas",
      plazo: "1 año desde sentencia firme",
      procedencia: "Sentencias firmes en casos de error judicial grave",
      tribunal: "Corte Suprema"
    },
    {
      nombre: "Recurso de Nulidad (Penal)",
      descripcion: "Contra sentencias definitivas penales",
      plazo: "10 días desde notificación",
      procedencia: "Sentencia de TOP o procedimiento simplificado",
      tribunal: "Corte de Apelaciones o Corte Suprema"
    },
    {
      nombre: "Recurso de Nulidad (Laboral)",
      descripcion: "Contra sentencias definitivas laborales",
      plazo: "10 días hábiles desde notificación",
      procedencia: "Sentencias definitivas laborales",
      tribunal: "Corte de Apelaciones"
    }
  ],
  constitucionales: [
    {
      nombre: "Recurso de Protección",
      descripcion: "Ante actos u omisiones arbitrarias o ilegales que priven, perturben o amenacen derechos constitucionales",
      plazo: "30 días corridos desde el acto",
      procedencia: "Derechos del Art. 19 CPR (listado taxativo)",
      tribunal: "Corte de Apelaciones"
    },
    {
      nombre: "Recurso de Amparo (Habeas Corpus)",
      descripcion: "Por privación, perturbación o amenaza a la libertad personal",
      plazo: "Sin plazo (urgente)",
      procedencia: "Libertad personal y seguridad individual",
      tribunal: "Corte de Apelaciones"
    },
    {
      nombre: "Acción de Inaplicabilidad",
      descripcion: "Declarar inaplicable un precepto legal en gestión pendiente",
      plazo: "Mientras esté pendiente la gestión",
      procedencia: "Precepto legal contrario a la Constitución",
      tribunal: "Tribunal Constitucional"
    }
  ]
};

// Plazos importantes
export const PLAZOS_JUDICIALES = {
  civiles: [
    { concepto: "Contestación demanda ordinaria", plazo: "15 días + tabla emplazamiento" },
    { concepto: "Contestación demanda sumaria", plazo: "8 días" },
    { concepto: "Excepciones juicio ejecutivo", plazo: "4 días (o según tabla)" },
    { concepto: "Apelación civil", plazo: "10 días" },
    { concepto: "Casación", plazo: "15 días" },
    { concepto: "Recurso de protección", plazo: "30 días corridos" }
  ],
  penales: [
    { concepto: "Plazo investigación formalizada", plazo: "2 años (prorrogables)" },
    { concepto: "Apelación penal", plazo: "5 días" },
    { concepto: "Recurso de nulidad penal", plazo: "10 días" },
    { concepto: "Preparación juicio oral", plazo: "25-35 días desde auto apertura" }
  ],
  laborales: [
    { concepto: "Demanda por despido", plazo: "60 días hábiles desde separación" },
    { concepto: "Audiencia preparatoria", plazo: "35 días desde demanda" },
    { concepto: "Recurso de nulidad laboral", plazo: "10 días hábiles" },
    { concepto: "Ejecución sentencia laboral", plazo: "60 días desde ejecutoriada" }
  ],
  familia: [
    { concepto: "Audiencia preparatoria alimentos", plazo: "10 días desde demanda" },
    { concepto: "Medidas cautelares VIF", plazo: "Inmediato" },
    { concepto: "Apelación familia", plazo: "10 días" }
  ]
};

export default JUDICIAL_SYSTEM;
